import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { Layout as AntdLayout, Button, Menu, Spin, theme, Typography } from 'antd';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useAdmin } from '../hooks/use-admin';
import { routes } from '../router';
import { Spacer } from './Spacer';

const { Header, Content: AntdContent, Footer, Sider } = AntdLayout;

export const Layout = ({ children }) => {
  const { loading, admin } = useAdmin();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const location = useLocation();
  const navigate = useNavigate();

  if (loading) {
    return (
      <Loader>
        <Spin />
      </Loader>
    );
  }

  if (!admin) return <Navigate to="/login" />;

  return (
    <AntdLayout>
      <Sider breakpoint="md" collapsedWidth="0" trigger={<Trigger id="trigger" />}>
        <Logo>
          <img src="/logo.png" alt="logo" />
        </Logo>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[location.pathname]}
          items={routes
            .filter((item) => item.inNavbar)
            .map((item) => ({
              key: item.path,
              icon: item.icon,
              label: item.label,
            }))}
          onClick={(item) => navigate(item.key)}
        />
      </Sider>
      <AntdLayout style={{ minHeight: '100vh' }}>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <HeaderContent>
            <MobileBurger>
              <div className="content">
                <Button
                  size="small"
                  icon={<MenuOutlined />}
                  onClick={() => {
                    const trigger = document.getElementById('trigger');
                    trigger.click();
                  }}
                />
              </div>
            </MobileBurger>
            <UserInfo>
              <Typography.Text>{admin.email}</Typography.Text>
              <Spacer w={16} />
              <Button
                size="small"
                danger
                icon={<LogoutOutlined />}
                onClick={() => {
                  localStorage.clear();
                  navigate('/login');
                }}
              />
            </UserInfo>
          </HeaderContent>
        </Header>
        <Content>
          <View background={colorBgContainer} borderradius={borderRadiusLG}>
            {children}
          </View>
        </Content>
        <Footer style={{ textAlign: 'center' }}>Arteller ©{new Date().getFullYear()}</Footer>
      </AntdLayout>
    </AntdLayout>
  );
};

const View = styled.div`
  padding: 24px;
  background: ${(props) => props.background};
  border-radius: ${(props) => props.borderradius}px;

  @media only screen and (max-width: 800px) {
    padding: 16px;
  }
`;

const Content = styled(AntdContent)`
  margin: 24px 16px 0;
`;

const Logo = styled.div`
  padding: 12px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 32px;
    width: 100%;
    object-fit: contain;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 16px;
`;

const MobileBurger = styled.div`
  .content {
    display: none;

    @media only screen and (max-width: 768px) {
      display: flex;
      flex-direction: row;
    }
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const Trigger = styled.div`
  display: none;
`;

const Loader = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
